import * as actionTypes from './actionTypes';

export const toggleTwoDUpdate=()=>({
    type:actionTypes.TOGGLE_TWOD_UPDATE
})